import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import { Button } from "@/ui/components/ui/button"

const ButtonLink = createLink((props: ComponentProps<typeof Button>) => (
  <Button nativeButton={false} render={<a />} {...props} />
))

export default ButtonLink
